import React from 'react';
import { Helmet } from 'react-helmet';
import BrandIdentityDevelopment from './BrandIdentityDevelopment';

const BrandIdentityDevelopmentPage = () => (
  <>
    <Helmet>
      <title>Brand Identity Development | MilaajBrandset</title>
      <meta
        name="description"
        content="Craft a distinctive brand identity that tells your story and resonates with your audience. MilaajBrandset focuses on creating a cohesive brand image that reflects your values and stands out in the market."
      />
      <meta
        name="keywords"
        content="Brand Identity Development, Logo Design, Brand Messaging, Style Guides, Brand Strategy, MilaajBrandset"
      />
      <meta property="og:title" content="Brand Identity Development | MilaajBrandset" />
      <meta
        property="og:description"
        content="Craft a distinctive brand identity that tells your story and resonates with your audience. MilaajBrandset focuses on creating a cohesive brand image that reflects your values and stands out in the market."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.milaajbrandset.com/brand-identity-development" />
      <meta property="og:image" content="https://www.milaajbrandset.com/images/brand-identity-og-image.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Brand Identity Development | MilaajBrandset" />
      <meta
        name="twitter:description"
        content="Craft a distinctive brand identity that tells your story and resonates with your audience. MilaajBrandset focuses on creating a cohesive brand image that reflects your values and stands out in the market."
      />
      <meta name="twitter:image" content="https://www.milaajbrandset.com/images/brand-identity-twitter-image.jpg" />
    </Helmet>
    <BrandIdentityDevelopment />
  </>
);

export default BrandIdentityDevelopmentPage;